<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper" [appDeviceClass]="'custom-scroll custom-scroll-t'">
        <div class="title_modal" (click)="log()">
            <div class="tab" (click)="selectTab(1)" [ngClass]="{'active': activeTabInd == 1}" *ngIf="data.jobTMPL">
                {{ "Job automation template" | translate }}
            </div>
            <div class="tab" (click)="selectTab(0)" [ngClass]="{'active': activeTabInd == 0}">
                <ng-container *ngIf="!!data.tmpl; else elseTemplateAdd">
                    {{ "Edit job automation template" | translate }}
                </ng-container>
                <ng-template #elseTemplateAdd>
                    {{ "Add job automation template" | translate }}
                </ng-template>
            </div>
            <span class="ml-1" *ngIf="data.tmpl" style="font-weight: 400; color: #000;">ID: {{data.tmpl.id}}</span>
        </div>
        <form [formGroup]="form" class="form_with_pads form_with_valids">
            <mat-form-field appearance="standard" class="full_width_form">
                <ng-container *ngIf="!form.get('name').valid && submited">
                    <div class="req_field"></div>
                    <div class="req_label">
                        <div class="angle"></div>
                        <span>
                            {{ "You need to write here" | translate }}
                        </span>
                    </div>
                </ng-container>
                <mat-label>{{ 'Template title' | translate }}</mat-label>
                <input formControlName="name" matInput placeholder="{{ 'Template title' | translate }}">
            </mat-form-field>

            <div class="small_chips" *ngIf="automationType?.length > 0 && !data.tmpl">
                <ng-container *ngIf="!form.get('scenario_name').valid && submited">
                    <div class="req_field"></div>
                    <div class="req_label">
                        <div class="angle"></div>
                        <span>
                            {{ "You need to choose a value" | translate }}
                        </span>
                    </div>
                </ng-container>
                <label>{{ "Automation type" | translate }}: </label>
                <mat-chip-list [multiple]="false" selectable formControlName="scenario_name">
                    <ng-container *ngFor="let aType of automationType">
                        <mat-chip class="small_chip" (click)="selectAutomationType(aType)" [value]="aType">
                            {{ aType | translate }}
                        </mat-chip>
                    </ng-container>
                </mat-chip-list>
            </div>

            <ng-container *ngIf="form.get('scenario_data').get('is_task_operation_one_per_template')">
                <ng-container formGroupName="scenario_data">

                    <div class="small_chips" *ngIf="operationStatuses?.length > 0">
                        <ng-container *ngIf="!form.get('scenario_data').get('status_id').valid && submited">
                            <div class="req_field"></div>
                            <div class="req_label">
                                <div class="angle"></div>
                                <span>
                                    {{ "You need to choose a value" | translate }}
                                </span>
                            </div>
                        </ng-container>
                        <label>{{ "Status after which it is executed" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable formControlName="status_id">
                            <ng-container *ngFor="let status of operationStatuses">
                                <mat-chip class="small_chip" (click)="selectStatus(status)" [value]="status?.id" [ngClass]="{
                                    'first': status.id == '1',
                                    'second': status.id == '2',
                                    'third': status.id == '3',
                                    'fours': status.id == '4',
                                    'fives': status.id == '5',
                                    'sixs': status.id == '6',
                                    'nine': status.id == '97',
                                    'seven': status.id == '98',
                                    'eight': status.id == '99'}">
                                    {{ status.name | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
    
                    <div class="small_chips" *ngIf="operations?.length > 0">
                        <ng-container *ngIf="!form.get('scenario_data').get('operation_id').valid && submited">
                            <div class="req_field"></div>
                            <div class="req_label">
                                <div class="angle"></div>
                                <span>
                                    {{ "You need to choose a value" | translate }}
                                </span>
                            </div>
                        </ng-container>
                        <label>{{ "New job type" | translate }}: </label>
                        <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                            <mat-select [disableOptionCentering]="true" selectDir  #operationId2Container formControlName="operation_id" (selectionChange)="selectType($event)">
                                <mat-option>
                                    <ngx-mat-select-search 
                                    placeholderLabel="{{ 'Search' | translate }}" 
                                    noEntriesFoundLabel="{{ 'no matching job type found' | translate }}"
                                    [formControl]="operationMoreControl"></ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let operation of operations$ | async" [value]="operation.id">
                                    {{ operation.name | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-chip-list [multiple]="false" selectable formControlName="operation_id">
                            <ng-container *ngFor="let operation of operations; let i = index">
                                <mat-chip class="small_chip" (click)="selectType(operation)" [value]="operation?.id">
                                    {{ operation.name | translate }}
                                </mat-chip>
                                <mat-chip *ngIf="i == operations?.length - 1 && i > 6" class="small_chip more" (click)="operationId2Container.open()">
                                    {{ "More..." | translate }}
                                </mat-chip>
                            </ng-container>
                            
                        </mat-chip-list>
                    </div>
    
    
                    <div class="small_chips">
                        <label>{{ "Choose a scenario" | translate }}: </label>
                        <mat-chip-list [multiple]="true" selectable formControlName="task_operation_automation_templates_ids" *ngIf="!scnSwitch">
                            <ng-container *ngFor="let template of templates; let i = index">
                                <mat-chip style="padding-left: 12px !important;" class="chip_user" (click)="toggleChipTemplate(template)" [value]="template.id" >
                                    {{ template.name }}
                                </mat-chip>
                                <mat-chip *ngIf="i == templates.length - 1 && i > 6" class="chip_user more" (click)="templatesIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <!-- (optionSelected)=“function($event)” try this -->
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                        <mat-select [multiple]="true" #templatesIdContainer formControlName="task_operation_automation_templates_ids" (selectionChange)="toggleChipTemplate($event)">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching template found' | translate }}"
                                [formControl]="templatesMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let template of templates$ | async" [value]="template.id">
                                {{template.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
    
                    <div class="file_tags_out" style="padding-bottom: 18px;">
                        <label>{{ "Job Tags" | translate }}: </label>
                        <div class="file_tags">
                            <ng-container *ngIf="parameters && parameters.length && parameters[0] && parameters[0].activeValues && parameters[0].activeValues.length">
                                <div class="file_tag" *ngFor="let tag of parameters[0].activeValues; let t = index;">
                                    <mat-icon class="verified" (click)="togglePrimary(tag)" [ngClass]="{'cst_primary': !!tag.is_primary}">verified</mat-icon>
                                    {{tag.value}}
                                    <div class="remove_out">
                                        <div class="remove" (click)="onRemove(tag, t)">
                                            <svg style="width: 5px; height: 5px;" width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 0.503571L4.49643 0L2.5 1.99643L0.503571 0L0 0.503571L1.99643 2.5L0 4.49643L0.503571 5L2.5 3.00357L4.49643 5L5 4.49643L3.00357 2.5L5 0.503571Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="add_tag cp" (click)="openTargetValues()">
                                <svg style="width: 16px; height: 16px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8.8H8.8V12H7.2V8.8H4V7.2H7.2V4H8.8V7.2H12M8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z" fill="#C4C4C4"/>
                                </svg>
                                {{ "Tag" | translate }}
                            </div>
                        </div>
                    </div>
    
                    <mat-form-field appearance="legacy" class="full_width_form" *ngIf="parameters">
                        <mat-label>{{ "Same tag values as in source job from tag(s)" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" [multiple]="true" selectDir formControlName="task_operation_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="!!form.get('scenario_data').get('task_operation_parameters_ids').value && !!form.get('scenario_data').get('task_operation_parameters_ids').value.length">
                                    <span *ngFor="let id of form.get('scenario_data').get('task_operation_parameters_ids').value">
                                        {{getParamById(id)?.name}}
                                    </span>
                                </ng-container>
                            </mat-select-trigger>
                          <mat-option>
                            <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag found' | translate }}"
                                [formControl]="parametersCtrl"></ngx-mat-select-search>
                          </mat-option>
                          <ng-container *ngFor="let parameter of parameters$ | async">
                              <mat-option *ngIf="!!parameter.id" [value]="parameter.id">
                                {{parameter.name}}
                              </mat-option>
                          </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="legacy" class="full_width_form" *ngIf="parameters">
                        <mat-label>{{ "Don't create the Job type with tag if it's created by this template" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" [multiple]="true" selectDir formControlName="task_operation_one_with_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="!!form.get('scenario_data').get('task_operation_one_with_parameters_ids').value && !!form.get('scenario_data').get('task_operation_one_with_parameters_ids').value.length">
                                    <span *ngFor="let id of form.get('scenario_data').get('task_operation_one_with_parameters_ids').value">
                                        {{getParamById(id)?.name}}
                                    </span>
                                </ng-container>
                            </mat-select-trigger>
                          <mat-option>
                            <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag found' | translate }}"
                                [formControl]="parametersCtrl"></ngx-mat-select-search>
                          </mat-option>
                          <ng-container *ngFor="let parameter of parameters$ | async">
                              <mat-option *ngIf="!!parameter.id" [value]="parameter.id">
                                {{parameter.name}}
                              </mat-option>
                          </ng-container>
                        </mat-select>
                    </mat-form-field>
    
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                        <mat-select #operationIdContainer formControlName="operation_id" (selectionChange)="selectType($event)">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching job type found' | translate }}"
                                [formControl]="operationMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let operation of operations$ | async" [value]="operation.id">
                                {{ operation.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </ng-container>
        </form>
    
        <ng-container *ngIf="form.get('scenario_data').get('is_task_operation_one_per_template')">
            <div class="block_w8 form_with_pads" style="margin: 20px 40px;">
                <div class="label_w8" style="margin: 0;">{{"Executors" | translate}}</div>
    
                <!-- <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                    <label>{{ "Individuals" | translate }}: </label>
                    <mat-chip-list [multiple]="true" selectable *ngIf="!emplSwitch">
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_employee')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_employee').value">
                            {{ "Assign by executor settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_employee_assistant')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_employee_assistant').value">
                            {{ "Assign by assistant settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_employee')" [selected]="!!form.get('scenario_data').get('is_inherit_task_employee').value">
                            {{ "Inherit executor" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_employee_assistant')" [selected]="!!form.get('scenario_data').get('is_inherit_task_employee_assistant').value">
                            {{ "Inherit assistant" | translate }}
                        </mat-chip>
                        <ng-container *ngFor="let employee of employees; let i = index">
                            <mat-chip class="chip_user" (click)="toggleAddChip(employee)" [value]="employee.id" [selected]="!!form.get('scenario_data').get('employees_ids').value.includes(employee.id)">
                                <app-user [class]="'user_div'" [employee]="employee"></app-user>
                            </mat-chip>
                            <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="employeeIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div> -->
                <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                    <label>{{ "Individuals" | translate }}: </label>
                    <mat-chip-list [multiple]="true" selectable *ngIf="!emplSwitch">
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_employee')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_employee').value">
                            {{ "Assign by executor settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_employee_assistant')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_employee_assistant').value">
                            {{ "Assign by assistant settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_employee')" [selected]="!!form.get('scenario_data').get('is_inherit_task_employee').value">
                            {{ "Inherit executor" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_employee_assistant')" [selected]="!!form.get('scenario_data').get('is_inherit_task_employee_assistant').value">
                            {{ "Inherit assistant" | translate }}
                        </mat-chip>
                        <ng-container *ngFor="let employee of employees; let i = index">
                            <mat-chip class="chip_user" (click)="toggleEmplChip(employee)" [value]="employee.id" [selected]="includesEmpl(employee.id)">
                                <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                <mat-icon *ngIf="!includesEmpl(employee.id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                                <mat-icon *ngIf="!includesEmpl(employee.id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                                <ng-container *ngIf="includesEmpl(employee.id)">
                                    <mat-icon style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Is Employee' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setEmpl($event, employee.id, 0)" 
                                        *ngIf="!!getEmpl(employee.id)?.is_manager">thumb_up</mat-icon>
                                    <mat-icon 
                                        style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Is Assistant' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setEmpl($event, employee.id, 1)" 
                                        *ngIf="!getEmpl(employee.id)?.is_manager">thumb_up_off_alt</mat-icon>
                                </ng-container>

                                <div class="menu_board" *ngIf="includesEmpl(employee.id)" [matMenuTriggerFor]="menu" (click)="$event.preventDefault(); $event.stopPropagation();">
                                    <ng-container *ngIf="getEmpl(employee.id)?.status_priority_order_after === null; else elseTemplateHasBoard">
                                        <mat-icon #tooltip="matTooltip"
                                        matTooltip="{{'Do not add to board' | translate}}"
                                        [matTooltipPosition]="'above'">web_asset_off</mat-icon>
                                    </ng-container>
                                    <ng-template #elseTemplateHasBoard>
                                        <mat-icon      
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Add to top of board' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        *ngIf="getEmpl(employee.id)?.status_priority_order_after === 0" style="transform: rotate(90deg);">first_page</mat-icon>
                                        <mat-icon      
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Add to bottom of board' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        *ngIf="getEmpl(employee.id)?.status_priority_order_after === -1" style="transform: rotate(90deg);">last_page</mat-icon>
                                    </ng-template> 
                                </div>
                                <mat-menu #menu="matMenu" class="sort_tablet new_sort_int" xPosition='before' overlayPanelClass='sortTAB'>
                                    <button mat-menu-item (click)="setEmplBoard(employee.id, 0)" [ngClass]="{'active_status': getEmpl(employee.id)?.status_priority_order_after === 0}">
                                        <mat-icon style="transform: rotate(90deg);">first_page</mat-icon>
                                        <span>{{"Add to top of board" | translate}}</span>
                                    </button>
                                    <button mat-menu-item (click)="setEmplBoard(employee.id, -1)" [ngClass]="{'active_status': getEmpl(employee.id)?.status_priority_order_after === -1}">
                                        <mat-icon style="transform: rotate(90deg);">last_page</mat-icon>
                                        <span>{{"Add to bottom of board" | translate}}</span>
                                    </button>
                                    <button mat-menu-item (click)="setEmplBoard(employee.id, null)" [ngClass]="{'active_status': getEmpl(employee.id)?.status_priority_order_after === null}">
                                        <mat-icon>web_asset_off</mat-icon>
                                        <span>{{"Do not add to board" | translate}}</span>
                                    </button>
                                </mat-menu>
                                  
                            </mat-chip>
                            <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="employeeIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>
    
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <!-- <mat-select #employeeIdContainer formControlName="employees_ids" multiple (selectionChange)="toggleAddChip($event)"> -->
                    <mat-select #employeeIdContainer [(ngModel)]="sbmtEmplIds" multiple (selectionChange)="toggleSelectEmplChip($event)">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching employees found' | translate }}"
                            [formControl]="employeeMoreControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                            <app-user [class]="'user_div'" [employee]="employee"></app-user>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
    
                                
                <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                    <label>{{ "Partners" | translate }}: </label>
                    <mat-chip-list [multiple]="true" selectable *ngIf="!partnerSwitch">
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_partner')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_partner').value">
                            {{ "Assign by partner settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_partner_assistant')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_partner_assistant').value">
                            {{ "Assign by partner assistant settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_partner')" [selected]="!!form.get('scenario_data').get('is_inherit_task_partner').value">
                            {{ "Inherit partner" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_partner_assistant')" [selected]="!!form.get('scenario_data').get('is_inherit_task_partner_assistant').value">
                            {{ "Inherit partner assistant" | translate }}
                        </mat-chip>
                        <ng-container *ngFor="let partner of partners; let i = index">
                            <mat-chip class="chip_user" (click)="togglePartnerChip(partner)" [value]="partner.partner_company_id" [selected]="includesPartner(partner.partner_company_id)">
                                <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                                <mat-icon *ngIf="!includesPartner(partner.partner_company_id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                                <ng-container *ngIf="includesPartner(partner.partner_company_id)">
                                    <mat-icon style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Is Employee' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setPartner($event, partner.partner_company_id, 0)" 
                                        *ngIf="!!getPartner(partner.partner_company_id)?.is_manager">thumb_up</mat-icon>
                                    <mat-icon 
                                        style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Is Assistant' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setPartner($event, partner.partner_company_id, 1)" 
                                        *ngIf="!getPartner(partner.partner_company_id)?.is_manager">thumb_up_off_alt</mat-icon>
                                </ng-container>
                            </mat-chip>
                            <mat-chip *ngIf="i == partners.length - 1 && i > 6" class="chip_user more" (click)="partnersIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>
    
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <mat-select #partnersIdContainer [(ngModel)]="sbmtPartnersIds" multiple (selectionChange)="toggleSelectPartnerChip($event)">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching partners found' | translate }}"
                            [formControl]="partnersControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id">
                            <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>


        <ng-container *ngIf="form.get('scenario_data').get('is_task_operation_one_per_template')">
            <div class="block_w8 form_with_pads" style="margin: 20px 40px;">
                <div class="label_w8" style="margin: 0;">{{"Clients" | translate}}</div>
                <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                    <label>{{ "Individuals" | translate }}: </label>
                    <div class="chips_spacer"></div>
                    <mat-chip-list [multiple]="true" selectable>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_client_principal')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_client_principal').value">
                            {{ "Assign by client moderator settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_client')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_client').value">
                            {{ "Assign by client settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_client')" [selected]="!!form.get('scenario_data').get('is_inherit_task_client').value">
                            {{ "Inherit client" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_client_principal')" [selected]="!!form.get('scenario_data').get('is_inherit_task_client_principal').value">
                            {{ "Inherit client moderator" | translate }}
                        </mat-chip>
                        <ng-container *ngFor="let employee of employees; let i = index">
                            <mat-chip class="chip_user" (click)="toggleClientChip(employee)" [selected]="includesCli(employee.id)" [value]="employee.id">
                                <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                <mat-icon *ngIf="!includesCli(employee.id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                                <ng-container *ngIf="includesCli(employee.id)">
                                    <mat-icon style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Permission to approve granted' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setCli($event, employee.id, 0)" 
                                        *ngIf="!!getCli(employee.id)?.is_principal">thumb_up</mat-icon>
                                    <mat-icon 
                                        style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                        #tooltip="matTooltip"
                                        matTooltip="{{'Permission to approve not granted' | translate}}"
                                        [matTooltipPosition]="'above'" 
                                        (click)="setCli($event, employee.id, 1)" 
                                        *ngIf="!getCli(employee.id)?.is_principal">thumb_up_off_alt</mat-icon>
                                </ng-container>
                            </mat-chip>
                            <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="cliCardEmployeeIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>
        
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <mat-select #cliCardEmployeeIdContainer multiple [(ngModel)]="clients_ids" (selectionChange)="toggleSelectClientChip($event)">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching individuals found' | translate }}"
                            [formControl]="employeeMoreControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                            <app-user [class]="'user_div'" [employee]="employee"></app-user>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
    
                <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                    <label>{{ "Partners" | translate }}: </label>
                    <div class="chips_spacer" *ngIf="!!pCliSwitch"></div>
                    <mat-chip-list [multiple]="true" selectable *ngIf="!pCliSwitch">
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_partner_client_principal')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_partner_client_principal').value">
                            {{ "Assign by partner client moderator settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_automation_employee_position_task_partner_client')" [selected]="!!form.get('scenario_data').get('is_automation_employee_position_task_partner_client').value">
                            {{ "Assign by partner client settings" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_partner_client')" [selected]="!!form.get('scenario_data').get('is_inherit_task_partner_client').value">
                            {{ "Inherit partner client" | translate }}
                        </mat-chip>
                        <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="toggleVal('is_inherit_task_partner_client_principal')" [selected]="!!form.get('scenario_data').get('is_inherit_task_partner_client_principal').value">
                            {{ "Inherit partner client moderator" | translate }}
                        </mat-chip>
                        <ng-container *ngFor="let partner of partners; let i = index">
                            <mat-chip class="chip_user" (click)="toggleClientPartnerChip(partner)" [selected]="includesCliPartn(partner.partner_company_id)" [value]="partner.partner_company_id">
                                <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                                <mat-icon *ngIf="!includesCliPartn(partner.partner_company_id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                            <ng-container *ngIf="includesCliPartn(partner.partner_company_id)">
                                <mat-icon 
                                #tooltip="matTooltip"
                                matTooltip="{{'Permission to approve granted' | translate}}"
                                [matTooltipPosition]="'above'" 
                                style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                (click)="setCliPartn($event, partner.partner_company_id, 0)" 
                                *ngIf="!!getCliPartn(partner.partner_company_id)?.is_principal">thumb_up</mat-icon>
                                <mat-icon 
                                #tooltip="matTooltip"
                                matTooltip="{{'Permission to approve not granted' | translate}}"
                                [matTooltipPosition]="'above'" 
                                style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                (click)="setCliPartn($event, partner.partner_company_id, 1)" 
                                *ngIf="!getCliPartn(partner.partner_company_id)?.is_principal">thumb_up_off_alt</mat-icon>
                            </ng-container>
                            </mat-chip>
                            <mat-chip *ngIf="i == partners.length - 1 && i > 6" class="chip_user more" (click)="cliCardPartnersIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>
        
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <mat-select #cliCardPartnersIdContainer multiple [(ngModel)]="partnerClients_ids" (selectionChange)="toggleSelectClientPartnerChip($event)">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching partners found' | translate }}"
                            [formControl]="partnersControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id">
                            <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
    
            <form [formGroup]="form" class="form_with_pads form_with_valids">
                <ng-container formGroupName="scenario_data">
    
                    <div class="small_chips" *ngIf="profileStatuses?.length > 0">
                        <label>{{ "Content statuses to be ignored when creating chats" | translate }}: </label>
                        <mat-chip-list [multiple]="true" selectable formControlName="skip_task_channel_status">
                            <ng-container *ngFor="let status of profileStatuses">
                                <mat-chip class="small_chip" (click)="selectProfileStatus(status.id)" [disabled]="status.is_user == 0" [value]="status.id">
                                    {{ status.name+'_profile' | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
                    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_link_discussion_status_to_task_channel">{{ "Is link discussion status to task channel?" | translate }}</mat-checkbox>
                    </div>
    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_execute_after_task_channel_created">{{ "Is execute after task channel created?" | translate }}</mat-checkbox>
                    </div>
                    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_skip_task_channel_with_url">{{ "Ignore if contains a link?" | translate }}</mat-checkbox>
                    </div>
    
                    <!-- <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_confirm_before_execute">{{ "Is confirmation required before execution?" | translate }}</mat-checkbox>
                    </div> -->
    
                    <!-- <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_confirm_multiple_employees">{{ "Confirm before execution if at least 1 channel has 2 or more executors?" | translate }}</mat-checkbox>
                    </div>
     -->
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_task_operation_one">{{ "Don't create a job if the job type already exists" | translate }}</mat-checkbox>
                    </div>
    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_task_operation_one_per_template">{{ "Do not create a job if that type of job has already been created by this template" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_discussion_one">{{ "Do not create a chat for a link if the chat has already been created" | translate }}</mat-checkbox>
                    </div>
    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_discussion_one_per_template">{{ "Do not create a chat for a link if the chat has already been created by this template" | translate }}</mat-checkbox>
                    </div>
                    <!-- OLD -->
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_copy_sources_files">{{ "Copy files from the sources folder" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_copy_project_files">{{ "Copy files from the project folder" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_copy_to_approve_files">{{ "Copy files from the to approve folder" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_copy_approved_files">{{ "Copy files from the approved folder" | translate }}</mat-checkbox>
                    </div>
    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_copy_ready_files">{{ "Copy files from the Ready folder" | translate }}</mat-checkbox>
                    </div>
    
                    <div class="box_wrp">
                        <mat-checkbox color="primary" (change)="changeCreateDiscussionFlag($event)" formControlName="is_create_discussions">{{ "Chats will be created based on the outlets in the card" | translate }}</mat-checkbox>
                    </div>
    
                    <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!form.get('scenario_data').get('is_create_discussions').value">
                        <mat-label>{{ "Discussion name template" | translate }}</mat-label>
                        <input formControlName="discussion_name_template" matInput>
                        <mat-hint>{{ "Use params channel_name and platform_name in this field with curly brackets" | translate }}</mat-hint>
                    </mat-form-field>
    
                </ng-container>
            </form>
            <div class="form_with_pads form_with_valids jobs_scen_wrp">
    
                <!-- feature chat id: 23450-->
                <div class="jobs_scen_title" (click)="logJobs()">{{"Execute only when all following jobs from the card meet requirements below:" | translate}}</div>
               
    
                <div class="job" *ngFor="let job of jobs; let i = index;">
                    <button mat-icon-button color="warn" class="delete_job" (click)="deleteJob(i)">
                        <mat-icon>do_disturb_on</mat-icon>
                    </button>
    
                    <div class="small_chips">
                        <label>{{ "Status" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.status_id">
                            <ng-container *ngFor="let status of operationStatuses">
                                <mat-chip class="small_chip" (click)="job.status_id = status.id" [selected]="job.status_id == status.id" [value]="status?.id" [ngClass]="{
                                    'first': status.id == '1',
                                    'second': status.id == '2',
                                    'third': status.id == '3',
                                    'fours': status.id == '4',
                                    'fives': status.id == '5',
                                    'sixs': status.id == '6',
                                    'nine': status.id == '97',
                                    'seven': status.id == '98',
                                    'eight': status.id == '99'}">
                                    {{ status.name | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
    
                    <div class="small_chips" *ngIf="operations?.length > 0">
                        <label>{{ "Job type" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.operation_id">
                            <ng-container *ngFor="let operation of operations; let i = index">
                                <mat-chip class="small_chip" (click)="job.operation_id = operation?.id" [value]="operation?.id" [selected]="job.operation_id == operation?.id">
                                    {{ operation.name | translate }}
                                </mat-chip>
                                <mat-chip *ngIf="i == operations?.length - 1 && i > 6" class="small_chip more" (click)="operationIdContainerNew.open()">
                                    {{ "More..." | translate }}
                                </mat-chip>
                            </ng-container>
                            
                        </mat-chip-list>
                    </div>
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                        <mat-select #operationIdContainerNew [(ngModel)]="job.operation_id">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching job type found' | translate }}"
                                [formControl]="operationMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let operation of operations$ | async" [value]="operation.id">
                                {{ operation.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Tag(s)" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" [(ngModel)]="job.parameter_values_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="job.parameter_values_ids && job.parameter_values_ids.length">
                                    <ng-container *ngFor="let id of job.parameter_values_ids">
                                        <span>{{ getValuesById(id)?.value }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag found' | translate }}"
                                [formControl]="allValuesControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let item of allValues$ | async" [value]="item.id">
                                <div class="d-f-c" style="justify-content: space-between;">
                                    <span>{{ item.value }}</span>
                                    <span>{{ item?.parameter?.name }}</span>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Tag categories" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" [(ngModel)]="job.parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="job.parameters_ids && job.parameters_ids.length">
                                    <ng-container *ngFor="let id of job.parameters_ids">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
    
                <div style="margin: 10px 40px;">
                    <div class="add_job" (click)="addJob()">
                        + {{ 'Add job' | translate }}
                    </div>
                </div>
            </div>
            <div class="form_with_pads form_with_valids" *ngIf="!!form.get('scenario_data').get('is_create_discussions').value">
                <div class="profile_add d-f-c">
                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Select publication outlet" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [(ngModel)]="addProfiles" multiple>
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="addProfiles && addProfiles.length">
                                    <ng-container *ngFor="let id of addProfiles">
                                        <span>
                                            <app-outlet-line [channel]="getProfileById(id)" [company_id]="company_id"></app-outlet-line>
                                        </span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching outlet found' | translate }}"
                                [formControl]="profilesMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let profile of profiles$ | async" [value]="profile.id" class="cst_o">
                                <app-outlet-line [channel]="profile" [company_id]="company_id"></app-outlet-line>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="add_profile" (click)="addChannels()" [ngClass]="{'disabled': !addProfiles.length}">
                        + {{ (addProfiles.length == 1 ? 'Outlet' : 'Outlets') | translate }}
                    </div>
                </div>
                <div class="profile_row" *ngFor="let profile of addedProfiles">
                    <div>
                        <app-outlet-line [channel]="profile" [company_id]="company_id"></app-outlet-line>
                        <!-- <div class="name">
                            <app-platform [platform_id]="profile?.platform_id"></app-platform>
                            <span>
                                {{ profile.name }}
                            </span>
                        </div> -->
                        <mat-checkbox class="parameter_check" [(ngModel)]="profile.is_common_parameter_value">{{ "Create a chat if the job and the channel have common parameter values" | translate }}</mat-checkbox>
                    </div>
                    <div class="empls">
                        <div class="users_select">
                            <label style="font-weight: 300;">{{ "Choose an employees" | translate }}: </label>
                            <mat-chip-list [multiple]="true" selectable [(ngModel)]="profile.employees_ids">
                                <ng-container *ngFor="let employee of employees; let i = index">
                                    <mat-chip class="chip_user" (click)="toggleEmpl(employee, profile)" [value]="employee.id">
                                        <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                    </mat-chip>
                                    <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="emploeeProfileContainer.open()">
                                        {{ "more" | translate }}
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-list>
                        </div>
            
                        <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                            <mat-select class="full_width_form hide-form-field" #emploeeProfileContainer [(ngModel)]="profile.employees_ids" multiple>
                                <mat-option>
                                    <ngx-mat-select-search 
                                    placeholderLabel="{{ 'Search' | translate }}" 
                                    noEntriesFoundLabel="{{ 'no matching executor found' | translate }}"
                                    [formControl]="employeeMoreControl"></ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                                    <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <button mat-icon-button color="warn" class="delete_profile" (click)="deleteChannel(profile)">
                        <mat-icon>do_disturb_on</mat-icon>
                    </button>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="form.get('scenario_name').value == 'TaskOperationContentPublisher'">
            <form [formGroup]="form" class="form_with_pads form_with_valids">
                <ng-container formGroupName="scenario_data">
                    <mat-form-field appearance="legacy" class="full_width_form" *ngIf="operationStatuses">
                        <mat-label>{{ "Job statuses" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" [multiple]="true" selectDir formControlName="status_ids">
                          <ng-container *ngFor="let status of operationStatuses">
                              <mat-option [value]="status.id">
                                {{status.name | translate}}
                              </mat-option>
                          </ng-container>
                        </mat-select>
                        <mat-hint>{{ "Will be executed for the selected statuses. If no status is selected, it will be executed regardless of status." | translate }}</mat-hint>
                    </mat-form-field>

                    <div class="set_status">
                        <div class="label_stat">{{"Set job status to" | translate}} </div>
                        <mat-form-field appearance="legacy" class="full_width_form" *ngIf="operationStatuses">
                            <mat-label>{{ "Select status" | translate }}</mat-label>
                            <mat-select [disableOptionCentering]="true" [multiple]="false" selectDir formControlName="published_status_id">
                              <ng-container *ngFor="let status of operationStatuses">
                                  <mat-option [value]="status.id">
                                    {{status.name | translate}}
                                  </mat-option>
                              </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <div class="label_stat"> {{"when scenario executed" | translate}}</div>
                    </div>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Job and Channel has same tag from tag category" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="channel_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('channel_parameters_ids').value && form.get('scenario_data').get('channel_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('channel_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ 'Minimum publish period (m)' | translate }}</mat-label>
                        <input formControlName="min_publish_period" matInput type="number" placeholder="{{ 'Minimum publish period (m)' | translate }}">
                        <mat-hint>{{"Minimum time to look for a publication slot from the moment the script is executed." | translate}}</mat-hint>
                    </mat-form-field>

                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_content_video">{{ "Wait for video file?" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_file_document_json_auto_post">{{ "Wait for the document with data to be published?" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_file_photo_thumbnail">{{ "Wait for the preview picture?" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_execute_after_task_channel_created">{{ "Is execute after task channel created?" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_execute_after_file_created">{{ "Is execute when adding a file to a job?" | translate }}</mat-checkbox>
                    </div>

                    <mat-divider style="margin: 15px 0;"></mat-divider>

                    <mat-form-field appearance="standard" class="full_width_form" #tooltip="matTooltip"
                    matTooltip="{{'Video with tag from stated tag category will be posted on the outlet with same tag from stated tag category.' | translate}}"
                    [matTooltipPosition]="'above'">
                        <mat-label>{{ "Video and outlet has the same tag from category" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="file_content_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('file_content_parameters_ids').value && form.get('scenario_data').get('file_content_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('file_content_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_file_content_without_parameters"                 
                        #tooltip="matTooltip"
                        matTooltip="{{'In this case if video has no tag then it will be posted on outlets with any tag from stated category tags' | translate}}"
                        [matTooltipPosition]="'above'" >{{ "Use video that hasn't tag from this category" | translate }}</mat-checkbox>
                    </div>

                    <mat-divider style="margin: 15px 0;"></mat-divider>

                    <mat-form-field appearance="standard" class="full_width_form" #tooltip="matTooltip"
                    matTooltip="{{'Text doc with tag from stated tag category will be posted on the outlet with same tag from stated tag category.' | translate}}"
                    [matTooltipPosition]="'above'">
                        <mat-label>{{ "Text doc and outlet has the same tag from category" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="file_document_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('file_document_parameters_ids').value && form.get('scenario_data').get('file_document_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('file_document_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_file_document_without_parameters"                 
                        #tooltip="matTooltip"
                        matTooltip="{{'In this case if text doc has no tag then it will be posted on outlets with any tag from stated category tags' | translate}}"
                        [matTooltipPosition]="'above'" >{{ "Use text doc that hasn't tag from this category" | translate }}</mat-checkbox>
                    </div>
                    
                    <mat-divider style="margin: 15px 0;"></mat-divider>

                    <mat-form-field appearance="standard" class="full_width_form" #tooltip="matTooltip"
                    matTooltip="{{'Thumbnail with tag from stated tag category will be posted on the outlet with same tag from stated tag category.' | translate}}"
                    [matTooltipPosition]="'above'">
                        <mat-label>{{ "Thumbnail and outlet has the same tag from category" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="file_thumbnail_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('file_thumbnail_parameters_ids').value && form.get('scenario_data').get('file_thumbnail_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('file_thumbnail_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_file_thumbnail_without_parameters"                 
                        #tooltip="matTooltip"
                        matTooltip="{{'In this case if thumbnail has no tag then it will be posted on outlets with any tag from stated category tags' | translate}}"
                        [matTooltipPosition]="'above'">{{ "Use thumbnail that hasn't tag from this category" | translate }}</mat-checkbox>
                    </div>


                    <mat-divider style="margin: 15px 0;"></mat-divider>

                    <mat-form-field appearance="standard" class="full_width_form" #tooltip="matTooltip"
                    matTooltip="{{'Use Title and Description from posts from channels that has same tag from the tag category' | translate}}"
                    [matTooltipPosition]="'above'">
                        <mat-label>{{ "Use data from posts with tags category" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="task_channel_channel_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('task_channel_channel_parameters_ids').value && form.get('scenario_data').get('task_channel_channel_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('task_channel_channel_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_task_channel_data"                 
                        #tooltip="matTooltip"
                        matTooltip="{{'If no corresponded Autopost document then use Title and Description from published posts' | translate}}"
                        [matTooltipPosition]="'above'">{{ "Take the Title and description from published posts" | translate }}</mat-checkbox>
                    </div>
                    <div class="box_wrp">
                        <mat-checkbox color="primary" formControlName="is_task_channel_channel_without_parameters"                 
                        #tooltip="matTooltip"
                        matTooltip="{{'Use Title and Description from posts from channels without tags.' | translate}}"
                        [matTooltipPosition]="'above'">{{ "Use data from posts from channels without tags" | translate }}</mat-checkbox>
                    </div>
                    

                    <mat-divider style="margin: 15px 0;"></mat-divider>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Post on slot from regular schedules if there is tag match with card from one or more tag categories" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="content_plan_and_task_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('content_plan_and_task_parameters_ids').value && form.get('scenario_data').get('content_plan_and_task_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('content_plan_and_task_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Post on slot from regular schedules if there is tag match with job from one or more tag categories" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="content_plan_and_task_operation_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('content_plan_and_task_operation_parameters_ids').value && form.get('scenario_data').get('content_plan_and_task_operation_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('content_plan_and_task_operation_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Post on slot from regular schedules if there is tag match with file from one or more tag categories" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="content_plan_and_file_parameters_ids">
                            <mat-select-trigger class="multi_users">
                                <ng-container *ngIf="form.get('scenario_data').get('content_plan_and_file_parameters_ids').value && form.get('scenario_data').get('content_plan_and_file_parameters_ids').value.length">
                                    <ng-container *ngFor="let id of form.get('scenario_data').get('content_plan_and_file_parameters_ids').value">
                                        <span>{{ getParamById(id)?.name }}</span>
                                    </ng-container>
                                </ng-container>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                                [formControl]="paramControl"></ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let item of parameters$ | async">
                                <mat-option *ngIf="!!item.id" [value]="item.id">
                                    <span>{{ item.name }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </form>
        </ng-container>

        <ng-container *ngIf="form.get('scenario_name').value == 'TaskOperationFilesCollector'">
            <p class="p_source_table">{{"Find files in source location and copy into destination location" | translate}}</p>
            <div class="source_table">
                <div class="source_table_line source_table_head">
                    <div>{{"Source location" | translate}}</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>{{"Destination location" | translate}}</div>
                </div>
                <div class="source_table_line source_table_sub_head">
                    <div>{{"Card" | translate}}</div>
                    <div>{{"Job" | translate}}</div>
                    <div>{{"Files" | translate}}</div>
                    <div>{{"Execute" | translate}}</div>
                    <div>{{"Put to" | translate}}</div>
                </div>
                <div class="source_table_line" *ngFor="let source of sources; let i = index;">
                    <div>
                        <div *ngIf="!!source.is_task_related">{{ "Related cards" | translate}}</div>
                        <div *ngIf="!!source.is_task_consist_of">{{ "Part of cards" | translate}}</div>
                        <div *ngIf="!!source.is_task_part_of">{{ "Consist of cards" | translate}}</div>
                        <div *ngIf="!!source.is_task_parent">{{ "Current card" | translate}}</div>
                        <div class="items_by_id" *ngIf="source.task_statuses_ids && source.task_statuses_ids.length">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_statuses_ids">
                                {{getTaskStatusesById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id" *ngIf="source.task_groups_ids && source.task_groups_ids.length">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_groups_ids">
                                {{getGroupById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id" *ngIf="source.task_parameter_values_ids && source.task_parameter_values_ids.length">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_parameter_values_ids">
                                {{getValuesById(item)?.value}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="items_by_id" *ngIf="source.task_operation_operations_ids && source.task_operation_operations_ids.length">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_operations_ids">
                                {{getOperationsById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id" *ngIf="source.task_operation_statuses_ids && source.task_operation_statuses_ids.length">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_statuses_ids">
                                {{getOperationStatusesById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.task_operation_employees_ids && source.task_operation_employees_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_employees_ids">
                                {{getEmployeeById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.task_operation_partner_companies_ids && source.task_operation_partner_companies_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_partner_companies_ids">
                                {{getPartnerById(item)?.partnerCompany?.name}}
                            </div>
                        </div>
                        <div *ngIf="!!source.is_skip_task_operation_parameters" class="text_one_line">{{ "Skip this check" | translate}}</div>
                        <div *ngIf="!!source.is_none_task_operation_parameters" class="text_one_line">{{ "Execute if source job has no such tag(s) either" | translate}}</div>
                        <div class="items_by_id d-f-c" *ngIf="source.task_operation_parameters_ids && source.task_operation_parameters_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_parameters_ids">
                                {{getParamById(item)?.name}}
                            </div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.task_operation_parameter_values_ids && source.task_operation_parameter_values_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.task_operation_parameter_values_ids">
                                {{getValuesById(item)?.value}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="items_by_id d-f-c" *ngIf="source.file_directories && source.file_directories.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.file_directories"><div>{{getFolderByLoc(item).name}} </div></div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.file_operation_reminders_ids && source.file_operation_reminders_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.file_operation_reminders_ids">{{getChecklistsById(item)?.text}} </div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.file_parameter_values_ids && source.file_parameter_values_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.file_parameter_values_ids">{{getValuesById(item)?.value}} </div>
                        </div>
                        <div class="items_by_id d-f-c" *ngIf="source.file_or_parameter_values_ids && source.file_or_parameter_values_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.file_or_parameter_values_ids" style="color: #4D76A1 !important;">{{getValuesById(item)?.value}} </div>
                        </div>
                        <div *ngIf="!!source.is_skip_file_parameters" class="text_one_line">{{ "Skip this check" | translate}}</div>
                        <div *ngIf="!!source.is_none_file_parameters" class="text_one_line">{{ "Execute if source file has no such tag(s) either" | translate}}</div>
                        <div class="items_by_id d-f-c" *ngIf="source.file_parameters_ids && source.file_parameters_ids.length" style="flex-wrap: wrap;">
                            <div class="item_by_id text_one_line" *ngFor="let item of source.file_parameters_ids">
                                {{getParamById(item)?.name}}
                            </div>
                        </div>
                    </div>
                    <div></div>
                    <div>
                        <ng-container *ngIf="!source.destination_directory; else elseTemplateHasDest">
                            <div class="btn_w8" (click)="setSource(true, source)">{{"Set destination" | translate}}</div>
                        </ng-container>
                        <ng-template #elseTemplateHasDest>
                            <div class="cp" (click)="setSource(true, source)">{{getFolderByLoc(source.destination_directory).name}}</div>
                        </ng-template>
                    </div>
                    <button style="color: #198058;" class="edit_source" mat-icon-button (click)="setSource(false, source)"><mat-icon>edit</mat-icon></button>
                    <button style="color: #C8232C;" class="delete_source" mat-icon-button (click)="deleteSource(i)"><mat-icon>delete</mat-icon></button>
                </div>
                <div class="source_table_line" >
                    <div>
                        <div class="btn_w8" (click)="setSource(false)">{{"Set source" | translate}}</div>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" cdkFocusInitial mat-raised-button color="primary" [disabled]="isSubmit" *ngIf="activeTabInd == 0">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>
            <ng-container *ngIf="!!data.tmpl; else elseTemplateAddSbmt">
                {{ "Edit" | translate }}
            </ng-container>
            <ng-template #elseTemplateAddSbmt>
                {{ "Add" | translate }}
            </ng-template>
        </button>
    </div>
</mat-dialog-actions>